import useResident from 'hooks/useResident'
import { Navigate, useParams } from 'react-router-dom'
import PersonalContactForm from '../forms/PersonalContactForm'

const ResidentPersonalContactUpdateScreen = ({
  testId
}: {
  testId?: string
} = {}) => {
  const { id, index } = useParams()

  if (!id) {
    return <Navigate to="/residents" />
  }

  const editedIndex = index ? parseInt(index, 10) : undefined

  if (editedIndex && Number.isNaN(editedIndex)) {
    // go to important contacts page
    return <Navigate to="../../" />
  }

  const { isLoading, resident, updateResident } = useResident({ id })

  return (
    <div
      data-testid={
        testId
          ? `${testId}-personal-contact-update-screen`
          : 'personal-contact-update-screen'
      }
    >
      <PersonalContactForm
        onSubmit={updateResident}
        isLoading={isLoading}
        resident={resident}
        editedIndex={editedIndex}
        testId={testId}
      />
    </div>
  )
}

export default ResidentPersonalContactUpdateScreen
